import axios from "axios";
import QS from "qs";
import md5 from "md5";
import * as Utils from "@utils/index.js";
import toast from "@com/dialogs/Toast/index.js";
import store from '@/store/index'

const urlParams = Utils.getParamsObj();
const isTest = window.ENV == "production" ? false : true;
const SECRET = window.ENV === "production" ? "bM8pkgycNx39TqT1lZ2wbmkRA2jbdXRs" : "ZS5R691BrVRUbvkfXhkcimhVTndzZLye";

axios.defaults.timeout = 1000 * 60;
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
// 允许携带cookie
axios.defaults.withCredentials = true;
axios.defaults.baseURL = `//${window.apiList[window.ENV]}`;

axios.interceptors.request.use(
  config => {
    let initParams = {
      appid: isTest ? "platform_test" : "platform_web", //正式：platform_web，测试：platform_test
      timestamp: Date.parse(new Date()) / 1000,
      k: urlParams?.k && urlParams.k.indexOf('#') > 0 ? urlParams.k.split('#')[0] : urlParams.k || "", //营销活动标识参数
      auth_token: store.state.userInfo.auth_token || '' //渠道中台(微信)授权标识
    };
    if (config.method == "get") {
      let wholeData = {
        ...initParams,
        ...config.params
      };
      // key按a->z升序排序
      let wholeDataBySort = Utils.objKeySort(wholeData);
      // 转换为url参数
      let wholeDataParams = Utils.procRequestParams(wholeDataBySort);
      console.log(`${wholeDataParams}&secret=${SECRET}`);
      let sign = md5(`${wholeDataParams}&secret=${SECRET}`).toUpperCase();
      console.log(sign);
      config.params = {
        ...initParams,
        ...config.params,
        sign
      };
    } else if (config.method == "post") {
      let conData = QS.parse(config.data);
      let wholeData = {
        ...initParams,
        ...conData
      };
      // key按a->z升序排序
      let wholeDataBySort = Utils.objKeySort(wholeData);
      let result = {};
      Object.entries(wholeDataBySort).map(item => {
        if (Object.prototype.toString.call(item[1]) === "[object Object]") {
          result[item[0]] = JSON.stringify(item[1]);
        } else {
          result[item[0]] = item[1];
        }
      });
      // 转换为url参数
      let wholeDataParams = Utils.procRequestParams(result);
      // console.log(`${wholeDataParams}&secret=${SECRET}`);
      let sign = md5(`${wholeDataParams}&secret=${SECRET}`).toUpperCase();
      config.data = decodeURIComponent(config.data) + "&" + QS.stringify(initParams) + "&sign=" + sign;
      // console.log(config.data);
    }
    return config;
  },
  error => {
    toast("请求失败，请检查网络后重试或联系客服");
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code != 0) {
      errorHandle(response);
    }
    return response;
  },
  function (error) {
    toast("请求失败，请检查网络后重试或联系客服");
    return Promise.reject(error);
  }
);

const errorHandle = response => {
  const res = response.data;
  switch (res.code) {
    case 401:
      // 重新授权
      store.dispatch('WECHAT_AUTH')
      break;
    case 404:
      location.href = `./404.html`;
      break;
    case 10001:
      // 绑定手机号
      toast(res.msg);
      store.commit('OPEN_DIALOG', 'Phone')
      break;
    case 10002:
      //关注公众号
      toast(res.msg);
      store.commit('OPEN_DIALOG', 'Follow')
      break;
    default:
      toast(res.msg);
      break;
  }
};

/**
 * @description: 请求方法封装
 * @param {String} url 【请求的url地址，默认空字符串】
 * @param {Object} params 【请求时携带的参数，默认空对象】
 * @param {String} type 【请求方法，默认get请求】
 * @return: 【Promise对象】
 */
export function $axios(url = "", params = {}, type = "GET") {
  let promise;
  return new Promise((resolve, reject) => {
    if (type.toUpperCase() === "GET") {
      promise = axios.get(url, { params });
    } else if (type.toUpperCase() === "POST") {
      promise = axios.post(url, QS.stringify(params));
    }
    promise
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
